var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 9.66634C4.44004 9.66634 1.33337 10.4463 1.33337 11.9997V13.1663H10.6667V11.9997C10.6667 10.4463 7.56004 9.66634 6.00004 9.66634ZM2.89337 11.833C3.45337 11.4463 4.80671 10.9997 6.00004 10.9997C7.19337 10.9997 8.54671 11.4463 9.10671 11.833H2.89337ZM6.00004 8.49967C7.28671 8.49967 8.33337 7.45301 8.33337 6.16634C8.33337 4.87967 7.28671 3.83301 6.00004 3.83301C4.71337 3.83301 3.66671 4.87967 3.66671 6.16634C3.66671 7.45301 4.71337 8.49967 6.00004 8.49967ZM6.00004 5.16634C6.55337 5.16634 7.00004 5.61301 7.00004 6.16634C7.00004 6.71967 6.55337 7.16634 6.00004 7.16634C5.44671 7.16634 5.00004 6.71967 5.00004 6.16634C5.00004 5.61301 5.44671 5.16634 6.00004 5.16634ZM10.6934 9.70634C11.4667 10.2663 12 11.013 12 11.9997V13.1663H14.6667V11.9997C14.6667 10.653 12.3334 9.88634 10.6934 9.70634ZM10 8.49967C11.2867 8.49967 12.3334 7.45301 12.3334 6.16634C12.3334 4.87967 11.2867 3.83301 10 3.83301C9.64004 3.83301 9.30671 3.91967 9.00004 4.06634C9.42004 4.65967 9.66671 5.38634 9.66671 6.16634C9.66671 6.94634 9.42004 7.67301 9.00004 8.26634C9.30671 8.41301 9.64004 8.49967 10 8.49967Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupFilterIcon);
export default __webpack_public_path__ + "static/media/group_filter_icon.b474ab0894062eeaaeaca59901a55c6a.svg";
export { ForwardRef as ReactComponent };